import { z } from "zod";

import { ctaBannerSectionSchema, heroSectionSchema, pageSeoSchema } from "@/content/schemas";
import { siteConfig } from "@/content/site";
import { validateContent } from "@/content/validateContent";

const aiCareerAdvantageThankYouPageSchema = z.object({
  seo: pageSeoSchema,
  hero: heroSectionSchema,
  finalCta: ctaBannerSectionSchema,
});

export const aiCareerAdvantageThankYouPageContent = validateContent(
  "aiCareerAdvantageThankYouPage",
  aiCareerAdvantageThankYouPageSchema,
  {
    seo: {
      title: "Thank You | AI Career Advantage Bundle",
      description: "Your AI Career Advantage Bundle purchase is confirmed. Check your email for instant digital access.",
      canonicalPath: "/ai-career-advantage/thank-you",
      socialImage: siteConfig.aiCareerAdvantageMockupImage,
      robots: "noindex, follow",
    },
    hero: {
      eyebrow: "Purchase Confirmed",
      title: "Thank You for Your Purchase",
      accent: "Check Your Email",
      description:
        "Your AI Career Advantage Bundle is on its way. Look for an email with your download links and access instructions.",
      secondaryDescription:
        "If you do not see the email within a few minutes, check your spam or promotions folder. For help, contact us directly.",
      align: "center",
      background: "muted",
      primaryCta: {
        label: "Email Support",
        href: `mailto:${siteConfig.email}?subject=AI%20Career%20Advantage%20Bundle%20Access`,
        external: true,
      },
      secondaryCta: {
        label: "Back to Bundle Page",
        href: "/ai-career-advantage",
        external: false,
      },
    },
    finalCta: {
      title: "Keep Learning With Tech Savvy Starts Here",
      description: "Subscribe to the newsletter for practical AI lessons, new resources, and workshop updates.",
      primaryCta: {
        label: "Subscribe to the Newsletter",
        href: siteConfig.beehiivSubscribeUrl,
        external: true,
      },
      secondaryCta: {
        label: "Watch on YouTube",
        href: siteConfig.youtubeUrl,
        external: true,
      },
      tone: "light",
    },
  },
);
